export const iconFontAwesomeFilesFileZipper = (
	<i className="fa-solid fa-file-zipper"></i>
);
